import { useEffect, useState } from 'react';

import { useAuth } from '@/services/auth';
import { updateAxiosToken } from '@/services/auth/authenticatedAxios';
import { AppBannerType, useAppBanner } from '../AppBanner';

export default ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated, getAccessTokenSilently, isLoading, user } = useAuth();
    const [axiosIsReady, setAxiosIsReady] = useState(false);
    const { open } = useAppBanner();

    useEffect(() => {
        if (isAuthenticated) {
            const cleanup = updateAxiosToken(getAccessTokenSilently);
            setAxiosIsReady(true);
            return cleanup;
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated && user) {
            if (user.isPrimary === false) {
                open({ type: AppBannerType.AccountNotPrimary });
            }
        }
    }, [isAuthenticated, user]);

    if (isLoading || !user || (!axiosIsReady && !user.isAnonymous)) {
        return null;
    }

    return <>{children}</>;
};
